module.exports = __webpack_public_path__ + "img/translationeditor_23.39e02ee2.jpg";